import React from "react";
import PropTypes from "prop-types";
import MDBox from "shared/ui/Box/MDBox";
import DayColumn from "features/planner/components/planner/DayColumn";

const DAYS = ["Día 1:", "Día 2:", "Día 3:", "Día 4:", "Día 5:", "Día 6:", "Día 7:"];

function PlannerGrid({ onEditSlot }) {
  return (
    <MDBox
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "stretch",
        height: "100%",
        gap: "16px",
      }}
    >
      {DAYS.map((day) => (
        <MDBox key={day} sx={{ flex: "1 1 0", minWidth: 0 }}>
          <DayColumn day={day} onEditSlot={onEditSlot} />
        </MDBox>
      ))}
    </MDBox>
  );
}

PlannerGrid.propTypes = {
  onEditSlot: PropTypes.func.isRequired,
};

export default PlannerGrid;
